// src/contexts/event-target.ts
import { createContext, useContext } from "react";
var EventTargetContext = createContext(void 0);
var useEventTarget = () => useContext(EventTargetContext);

export {
  EventTargetContext,
  useEventTarget
};
//# sourceMappingURL=chunk-YH7PRLMG.mjs.map